<template>
  <section class="campaign">
    <Header :user="user" />
    <main class="main  animated fadeIn faster" :class="{ 'expand-main' : isMenuCollapse }">
        <Fieldset :title="'Oliver\'s Calendars (Not sync)'"   mykey="9809889"  :open="false">
          <div class="row">
            <div  class="col-xl-3 col-lg-4 card m-0 p-2"
             :class="[calendar.notsync == '1' ? 'bg-event-nosync' : '', calendar.link_id == undefined ? 'bg-danger text-white' : '']"
              v-for="(calendar,key) in oliverCalendarsNotSync" :key="key+3283">
              <div class="mb-2">
                <router-link :to="'/opportunities/' + calendar.link_id" target="_blank">
                  <div class="text-primary" >
                    {{calendar.link_id}}
                  </div>
                </router-link>
               <i class="badge icon icon-checkmark text-success" v-if="calendar.data.activated == '1' && calendar.data.activated_spark == '0'">Nylas</i>
                <i class="badge icon icon-close text-danger" v-if="calendar.data.activated == '0' && calendar.data.activated_spark == '0'">Nylas</i>
               <i class="badge icon icon-checkmark text-success" v-if="calendar.data.activated_spark == '1'">Spark</i>
               <i class="badge icon icon-close text-danger" v-else>Spark</i>
               <i class="badge icon icon-link text-secondary" v-if="calendar.data.calendar_client_nylas_id">Ref.id={{calendar.data.calendar_client_nylas_id}}</i>

                <div>
               <small class="">Client id: {{calendar.data.client_id}} ({{calendar.data.client_status}})</small>
                </div>
                </div>

                <CalendlyEvent v-if="calendar.name !== undefined" :eventCalendly="calendar"></CalendlyEvent>
                <div v-if="calendar.name == undefined" >
                  {{calendar}}
                </div>
              </div>
            </div>
        </Fieldset>
        <Fieldset :title="'Oliver\'s Calendars'"  mykey="324343"  :open="false">
          <div class="row">
            <div  class="col-xl-2 col-lg-4 card m-2 p-2 ml-4"
             :class="[calendar.notsync == '1' ? 'bg-event-nosync' : '', calendar.link_id == undefined ? 'bg-danger text-white' : '']"
              v-for="(calendar,key) in oliverCalendars" :key="key">
               <div class="mb-2">
               <router-link :to="'/opportunities/' + calendar.link_id" target="_blank"
                 >
                  <div class="text-primary" >
                    {{calendar.link_id}}
                  </div>
                </router-link>
               <i class="badge icon icon-checkmark text-success" v-if="calendar.data.activated == '1' && calendar.data.activated_spark == '0'">Nylas</i>
                <i class="badge icon icon-close text-danger" v-if="calendar.data.activated == '0' && calendar.data.activated_spark == '0'">Nylas</i>
               <i class="badge icon icon-checkmark text-success" v-if="calendar.data.activated_spark == '1'">Spark</i>
               <i class="badge icon icon-close text-danger" v-else>Spark</i>
               <i class="badge icon icon-link text-secondary" v-if="calendar.data.calendar_client_nylas_id">Ref.id={{calendar.data.calendar_client_nylas_id}}</i>
                </div>

                <CalendlyEvent v-if="calendar.name !== undefined" :eventCalendly="calendar"></CalendlyEvent>
                <div v-if="calendar.name == undefined" >
                  {{calendar}}
                </div>
            </div>
          </div>
        </Fieldset>


        <div v-for="(calendar,key) in calendars">
          <Fieldset :title="calendar.name" :mykey="key" :open="false"
          @opennow="getEvents(calendar.calendly)" >
          <h6>{{calendar.users}}</h6>
            <small>{{calendar.calendly}}</small>
              <LoadingSpinner v-if="events[calendar.calendly] === undefined" />
            <div class="row" v-if="events[calendar.calendly] !== undefined">
              <div class="col-3 card m-2 p-2"
              :class="event.link_id == undefined ? 'bg-danger text-white' : 'bg-light'" v-for="event in events[calendar.calendly].collection">
                <div v-for="link in event.link_id">

                      <router-link :to="'/opportunities/' + link" target="_blank"
                       >
                        <div class="text-primary" >
                          {{ link }}
                        </div>
                      </router-link>
                </div>
               <CalendlyEvent :eventCalendly="event" />
              </div>
              <button v-if="!loadingnext && events[calendar.calendly].pagination !== undefined && events[calendar.calendly].pagination.next_page !== null" class="btn btn-sm btn-primary"
              @click="nextPage(calendar.calendly,events[calendar.calendly].pagination.next_page)">next</button>
               <LoadingSpinner v-if="loadingnext" />
            </div>
          </Fieldset>
        </div>
    </main>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import ViewDashboard from "@/components/Dashboard/ViewDashboard.vue";
import DashboardAdmin from "@/components/Dashboard/DashboardAdmin.vue";
import ToastNotifications from "@/components/ToastNotifications.vue";
import Fieldset from "@/components/Common/Fieldset.vue";
import CalendlyEvent from "@/components/Common/CalendlyEvent.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { calendlyService,clientsService } from "@/_services";


export default {

  data(){
    return{
        loadingcreate:false,
        rescreate:false,
        calendars:[],
        oliverCalendars:[],
        oliverCalendarsNotSync:[],
        events:[],
        loading:false,
        loadingnext:false
    }
  },

  created() {
     this.loading=true
      calendlyService.getCalendars().then(
      (result) => {
        this.calendars = result
        this.loading=false
      })
      
      clientsService.getAllCalendarNylas({}).then(
      (result) => {
        this.oliverCalendars = result
      })

      let filters = {'onlyunsync':true}
      clientsService.getAllCalendarNylas(filters).then(
      (result) => {
        this.oliverCalendarsNotSync = result
      })
  },

  components: {
    ToastNotifications,
    ViewDashboard,
    Fieldset,
    DashboardAdmin,
    CalendlyEvent,
    LoadingSpinner
  },

  computed: {
    ...mapState({
      headerTab: state => state.header.tab,
      isMenuCollapse: state => state.sidebar.isNavOpen,
      paymentMethods: state => state.billings.all
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },
  methods: {
    getEvents(token){
      calendlyService.getAllEvents(token,10).then((res) => {
        this.events[token] = res
        this.$forceUpdate()
      })
    },
    nextPage(token,url){
      this.loadingnext = true
      calendlyService.nextPage(url,token).then((res) => {
        res.collection.forEach((item, key) => {
          this.events[token].collection.push(item)
        })
        this.events[token].pagination = res.pagination
        this.$forceUpdate()
        this.loadingnext = false
      })
    }
  }
};
</script>
<style  scoped>
  .bg-event-nosync {
  background-color: #d7d3e0d2;
}
</style>
